import {GridColDef} from '@mui/x-data-grid-pro';
import {renderCellDate} from '../../../utils/renderCellDate';
import {renderCellCurrency} from '../../../utils/renderCellCurrency';

export const savingsColumns: GridColDef[] = [
  {
    field: 'contact',
    headerName: 'Owner',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell(params) {
      return params.value?.simplifiedName || '-';
    },
  },
  {
    field: 'ownership',
    headerName: 'Asset Ownership',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },
  {
    field: 'name',
    headerName: 'Asset Name',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },
  {
    field: 'category',
    headerName: 'Asset Category',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },

  {
    field: 'value',
    headerName: 'Current Value',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell: renderCellCurrency,
  },
  {
    field: 'valuationDate',
    headerName: 'Valuation Date',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell: renderCellDate,
  },
];
